export default "__VITE_ASSET__fM$06QgC__"